import React from "react";

export const LazyVirtualScrollExamplePage = React.lazy(
    () =>
        import(
            /* webpackChunkName: "VirtualScrollExamplePage" */ "./VirtualScrollExamplePage"
        )
);
